module.exports = "/to_the_arctic_for_practice/_next/static/videos/18-0b30fd0e08d726ec39a064a8c7009ec9.mp4";